import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-400 via-primary-500 to-accent-500 p-8 md:p-14 text-center">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-10 w-40 h-40 rounded-full bg-background-50"></div>
            <div className="absolute bottom-10 right-10 w-60 h-60 rounded-full bg-background-50"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full bg-background-50"></div>
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50">
              准备好开启你的追番之旅了吗？
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-200 max-w-lg mx-auto">
              海量正版高清动漫资源，日漫国漫一网打尽。加入小樱动漫，畅享极致追番体验。
            </p>
            <Link
              to="/categories"
              className="inline-flex mt-6 px-8 py-3 bg-background-50 text-primary-600 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即探索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}